// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1gPML","topBottomGutter":"Layout_topBottomGutter__3rf8M"};